<template>
  <div>
    <el-select
      class="select-primary"
      placeholder="Berechtigungen"
      :multiple="true"
      @change="$emit('input', selectedPermissions)"
      v-model="selectedPermissions"
    >
      <el-option
        v-for="(item, index) in permissions"
        :key="index"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { Tag, Select, Option } from "element-ui";
export default {
  components: {
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      selectedPermissions: []
    };
  },
  created() {
    if (this.value) {
      this.selectedPermissions = this.value.map(function(permission) {
        return permission.name;
      });
    }
    this.$emit("input", this.selectedPermissions);
    this.$store.dispatch("permissions/read");
  },
  props: {
    value: {
      required: true,
      default: () => []
    }
  },
  computed: {
    permissions() {
      return this.$store.getters["permissions/all"].map(function(permisson) {
        return { value: permisson.name };
      });
    }
  }
};
</script>

<style></style>
